import React, { useState, useEffect } from "react";
import { Collapse, Button, Skeleton, Alert, Checkbox, Drawer, Row } from "antd";
import { CaretRightOutlined } from "@ant-design/icons";
import { gql, useLazyQuery, useMutation } from "@apollo/client";
import UserContract from "@general/userContract";
import { useNavigate } from "react-router-dom";
import moment from "moment-jalaali";
function CardIssuing() {
  const navigate = useNavigate();
  const { Panel } = Collapse;
  const [card, setCard] = useState({});
  const [contractChekBox, SetContractChekbox] = useState(false);
  const [userContractDrawer, setUserContractDrawer] = useState(false);
  const [cardContract, setCardContract] = useState("");
  const REQUESTCARD = gql`
    mutation {
      createCardInvoice {
        id
      }
    }
  `;

  const GETCARDDATA = gql`
    query {
      getCardContract
      getMyCard {
        createdAt
        cardNo
        cardIdentifier
        deliveredAt
        issuedAt
        cardStatus
        deactivatedAt
      }
    }
  `;
  const [runRequestCard, requestCard] = useMutation(REQUESTCARD, {
    onError(err) {
      console.log("error: " + err.message);
    },
    onCompleted(data) {
      navigate(`/invoice/${data.createCardInvoice.id}`);
    },
  });
  const [getCardData, cardData] = useLazyQuery(GETCARDDATA, {
    onError(err) {
      console.log("error: " + err.message);
    },
    onCompleted({ getMyCard, getCardContract }) {
      setCard(getMyCard);
      setCardContract(getCardContract);
    },
    onError(err) {
      console.log("GETCARDDATA: ", err)
    }
  });

  useEffect(() => {
    getCardData();
  }, []);


  if (requestCard.loading)
    return (
      <>
        <Skeleton active round />
        <br />
        <Skeleton active round />
      </>
    );
  if (!card)
    return (
      <>
        <Drawer
          title={"تعهدنامه استفاده کارت عضویت"}
          placement="top"
          open={userContractDrawer}
          onClose={() => setUserContractDrawer(false)}
          height={450}
        >
          <UserContract
            contract={cardContract}
            onCloseDrawer={() => setUserContractDrawer(false)}
          />
        </Drawer>
        <div>
          <p>
            کارت تردد، کارتی است که همه‌ی اعضا هنگام عضویت در مرکز مشاوره و
            خدمات کارآفرینی صفاتک دریافت می‌کنند تا با آن در ساعات کاری مرکز
            امکان تردد داشته باشند.
          </p>
        </div>
        <div style={{ margin: "30px 0" }}>
          <Collapse
            bordered={false}
            expandIcon={({ isActive }) => (
              <CaretRightOutlined rotate={isActive ? 90 : 0} />
            )}
            className="site-collapse-custom-collapse"
          >
            <Panel
              header="چه کسانی کارت تردد دریافت می‌کنند؟"
              key="1"
              className="site-collapse-custom-panel"
            >
              <p>
                همه‌ی اعضای مرکز مشاوره و خدمات کارآفرینی صفاتک در هنگام ثبت نام
                ملزم به دریافت کارت تردد هستند. هر کارت متعلق به یک عضو و برای
                استفاده‌ی شخصی است. و ایشان متعهد به حفظ و نگهداری از این کارت
                هستند.
              </p>
            </Panel>
            <Panel
              header="داشتن کارت تردد برای اعضا الزامی است؟"
              key="2"
              className="site-collapse-custom-panel"
            >
              <p>بله. همه‌ی اعضا ملزم به دریافت یک کارت موقع ثبت نام هستند.</p>
            </Panel>
            <Panel
              header="در چه ساعاتی با استفاده از کارت می‌توانیم به مرکز رفت و آمد کنیم؟"
              key="3"
              className="site-collapse-custom-panel"
            >
              <p>
                رفت و آمد با استفاده از کارت در ساعات کاری مرکز که (که در سایت
                صفاتک موجود است) امکان پذیر است.
              </p>
            </Panel>
            <Panel
              header="اگر کارت تردد را گم کردیم چکار کنیم؟"
              key="4"
              className="site-collapse-custom-panel"
            >
              <p>
                در اسرع وقت به مدیر جامعه گزارش دهید تا از سوء استفاده‌های
                احتمالی جلوگیری شود.
              </p>
            </Panel>
          </Collapse>
        </div>
        <Row style={{ margin: "30px 0" }}>
          <Checkbox
            checked={contractChekBox}
            onChange={() => SetContractChekbox(!contractChekBox)}
          >
            <Button
              type="link"
              style={{ fontWeight: "bold" }}
              onClick={() => setUserContractDrawer(true)}
            >
              تعهدنامه
            </Button>
            مربوط به استفاده از کارت عضویت صفاتک را مطالعه کرده و شرایط آن را
            قبول میکنم.
          </Checkbox>
        </Row>
        <Button
          type="primary"
          onClick={() => runRequestCard()}
          disabled={!contractChekBox}
        >
          درخواست کارت
        </Button>
      </>
    );
  if (card && card?.deactivatedAt)
    return (
      <>
        <Alert
          type="warning"
          showIcon
          message={`کارت شما در تاریخ ${moment(card?.deactivatedAt).format(
            "jYYYY/jMM/jDD"
          )} غیر فعال شده است. لطفا به مدیر جامعه مراجعه کنید.`}
        ></Alert>
      </>
    );
  if (card?.cardStatus === "ISSUING")
    return (
      <>
        <Alert
          type="info"
          showIcon
          message={`درخواست کارت شما در تاریخ ${moment(card?.createdAt).format(
            "jYYYY/jMM/jDD"
          )} ثبت شده است و کارت شما درحال صدور میباشد.`}
        ></Alert>
      </>
    );
  if (card?.cardStatus === "DELIVERING")
    return (
      <>
        <Alert
          type="info"
          showIcon
          message={`کارت شما در تاریخ ${moment(card?.issuedAt).format(
            "jYYYY/jMM/jDD"
          )} صادر شده. برای تحویل گرفتن به مدیر جامعه مراجعه کنید.`}
        ></Alert>
      </>
    );
  if (card?.cardStatus === "DELIVERED")
    return (
      <>
        <Alert
          type="info"
          showIcon
          message={`کارت شما به شماره ${card?.cardNo || "نامشخص"} در تاریخ ${moment(card.deliveredAt).format("jYYYY/jMM/jDD") || " نامشخص"
            } تحویل داده شد.`}
        ></Alert>
      </>
    );
}

export default CardIssuing;
